import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1.5 font-mono-tech text-[11px] uppercase tracking-[0.15em]">
    <Link to="/" className="text-steel hover:text-amber-brand">Home</Link>
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-1.5">
        <ChevronRight size={11} className="text-line" aria-hidden="true" />
        {item.to ? (
          <Link to={item.to} className="text-steel hover:text-amber-brand">{item.label}</Link>
        ) : (
          <span className="text-amber-brand" aria-current="page">{item.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export const PageHero = ({ chapter, label, title, sub, crumbs }) => (
  <section className="relative bg-ink bg-blueprint border-b border-line overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 md:px-10 pt-32 md:pt-40 pb-14 md:pb-20">
      {crumbs && <div className="mb-8"><Breadcrumbs items={crumbs} /></div>}
      <div className="flex items-baseline gap-4 mb-4">
        <span className="font-mono-tech text-xs tracking-[0.25em] text-amber-brand uppercase">{chapter}</span>
        <span className="h-px w-10 bg-line" aria-hidden="true" />
        <span className="font-mono-tech text-xs tracking-[0.25em] text-steel uppercase">{label}</span>
      </div>
      <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-steel-light leading-[1.02] max-w-4xl">
        {title}
      </h1>
      {sub && <p className="mt-6 max-w-2xl text-steel text-base md:text-lg leading-relaxed">{sub}</p>}
    </div>
    <div className="ticks opacity-60" aria-hidden="true" />
  </section>
);
